import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent} from './containers';
import { AuthorizatedGuard } from './core/guards/authorizated.guard';
import { StorageService } from './services/storage.service';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page',
    },
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
      breadcrumb: 'migas.inicio'
    },
    children: [
      {
        path: 'main',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
          import('./views/main/main.module').then(
            (m) => m.MainModule
          )
      },
      {
        path: 'main/:id',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
          import('./views/main/main.module').then(
            (m) => m.MainModule
        )
      },
      {
        path: 'usuarios',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/usuarios/usuarios.module').then(
          (m) => m.UsuariosModule
        )
      } ,
      {
        path: 'tiendas',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/tiendas/tienda.module').then(
          (m) => m.TiendasModule
        )
      } ,
      {
        path: 'pagos',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/pago-varios/pago-varios.module').then(
          (m) => m.PagoVariosModule
        )
      } ,
      {
        path: 'pagos/:id',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/pago-varios/pago-varios.module').then(
          (m) => m.PagoVariosModule
        )
      },
      {
        path: 'servicios',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/servicios/servicios.module').then(
          (m) => m.ServiciosModule
        )
      } ,
      {
        path: 'servicios/tipos',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/tipos-servicio/tipo-servicio.module').then(
          (m) => m.TipoServiciosModule
        )
      } ,
      {
        path: 'informes',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/informes/informes.module').then(
          (m) => m.InformesModule
        )
      } ,
      {
        path: 'clientes',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/clientes/clientes.module').then(
          (m) => m.ClientesModule
        )
      } ,
      {
        path: 'tickets',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/tickets/ticket.module').then(
          (m) => m.TicketModule
        )
      } ,
      {
        path: 'productos',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/productos/productos.module').then(
          (m) => m.ProductosModule
        )
      } ,
      {
        path: 'bonos',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/bonos/bonos.module').then(
          (m) => m.BonosModule
        )
      },
      {
        path: 'bonoclientes',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/bonoclientes/bonoclientes.module').then(
          (m) => m.BonoclientesModule
        )
      },
      {
        path: 'caja',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/caja/caja.module').then(
          (m) => m.CajaModule
        )
      },
      {
        path: 'devoluciones',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/devoluciones/devoluciones.module').then(
          (m) => m.DevolucionesModule
        )
      },
      {
        path: 'albaranes',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/albaranes/albaranes.module').then(
          (m) => m.AlbaranesModule
        )
      },
      {
        path: 'configuraciones',
        canActivate: [ AuthorizatedGuard ],
        canLoad: [ AuthorizatedGuard ],
        loadChildren: () =>
        import('./views/configuraciones/configuraciones.module').then(
          (m) => m.ConfiguracionesModule
        )
      },
      // {
      //   path: 'desarrollo_features',
      //   canActivate: [ AuthorizatedGuard ],
      //   loadChildren: () =>
      //   import('./views/desarrollo/desarrollo.module').then(
      //     (m) => m.DesarrolloModule
      //   )
      // },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
}),
  ],
  exports: [RouterModule],
  providers: [AuthorizatedGuard, StorageService]
})
export class AppRoutingModule {}
